import { difference } from 'lodash-es'

const transformToUpdateScrapingTestCaseTags = (
  testCaseId,
  currentTagIds,
  previousTagIds,
) => {
  const newTagIds = difference(currentTagIds, previousTagIds)
  const removedTagIds = difference(previousTagIds, currentTagIds)
  return { id: testCaseId, newTagIds, removedTagIds }
}

export default transformToUpdateScrapingTestCaseTags
